import { ICustomerUser } from "./customer.user.model";
import { DecorationDraft, DecorationOption } from "./decoration.model";

export const ProductType = {
  clothing: "Clothing",
  ppe: "PPE",
  footwear: "Footwear",
  "workplace-safety": "Workplace Safety",
  decoration: "Decoration",
};

export enum AccessMode {
  Manual = 0,
  Authorised = 1,
  UnAuthorised = 2,
}

export class ProductOption {
  Guid?: string;
  ImageUrl!: string;
  Name!: string;
}

export interface IEnum {
  originalName?: string;
  isEdit?: boolean;
  name: string;
  id: string;

  // Used during UI only for ease of display
  children?: any[];
  parentId?: string;
  level?: string;
  count?: number;
  deletedAt?: string | null;
  createdAt?: string;
  logo?: string;
  description?: string;
  image1?: string;
  image2?: string;
  image3?: string;
  imageUrl?: string;
}

export interface EnumCreateParams {
  name: string;
  id: string;
  parentId?: string;
  children?: any[];
  level?: string;
  count?: number;
  imageUrl?: string
}

export interface ICreateCategory {
  imageUrl?: string;
  name: string;
  parentId?: string;
}

export interface Brand extends IEnum {}

export interface ICategory extends IEnum {}

export interface Label extends IEnum {}

/**
 * Begin Code Refactor
 */

export interface NewBrand {
  id: number;
  name: string;
}

export class NewCustomer {
  name!: string;
  code!: string;
  ccEmail!: string;
  deletedAt?: string;
  customerUsers!: ICustomerUser[];
  customerUserCount!: number;
  updatedByUser?: {
    firstName: string;
    lastName: string;
  };
  poLabelName?: string;
}

export class NewGroup {
  name!: string;
}

export class NewLabel {
  // id: string;
  text!: string;
}

/**
 * Amalgamation of the properties you expect to see on both decoration and product, for ease
 */
export class DecorationOrProduct {
  id?: number;
  isDraft!: boolean;
  name: string = "";
  accessMode: number = 1;
  weight!: number | null;
  basePrice!: number;
  price!: number | null;
  customers: ProductCustomer[] = [];
  variations: NewProductVariation[] = [];
  imageUrl!: string | null;
  images: ProductImage[] = [];
  inStock: boolean = false;
}

/**
 * Amalgamation of the properties you expect to see on both decoration and product, for ease
 */
export class Decoration {
  id?: number;
  isDraft!: boolean;
  name: string = "";
  accessMode: number = 1;
  weight!: number | null;
  basePrice!: number;
  price!: number | null;
  customers: DecorationCustomer[] = [];
  variations: NewProductVariation[] = [];
  imageUrl!: string | null;
  images: ProductImage[] = [];
  inStock: boolean = false;
  products: DecorationProducts[] = [];
}

export class NewDecoration extends Decoration {
  isRequired!: boolean;
  maxPerProduct?: number;
  options: DecorationOption[] = [];
  subsidyAmount!: number | null;
  updatedByUser?: {
    firstName: string;
    lastName: string;
  };

  deletedAt?: string | null;
}

export class NewProduct extends DecorationOrProduct {
  id?: number;
  code: string = "";
  brand!: NewBrand | null;
  gender!: string;
  brandId!: number | null;
  categories: Category[] = [];
  description: string = "";
  features: string = "";
  usePackSizes: boolean = false;
  packSizes: NewPackSize[] = [];
  decorations: NewDecoration[] = [];
  type: string = "";
  uri: string = "";
  dataSheetUrl!: string | null;
  sizeChartUrl!: string | null;
  sizeChartId!: number | null;
  //Temporary hoding
  sizeChart: any;
  deletedAt!: string;
  subsidyAmount!: number | null;
  variations!: NewProductVariation[];
  labels: any;
  temporarySelectedLabels: any;
  updatedAt!: string;
  brandName: () => string = () => (this.brand ? this.brand.name : "");
  fetchStock!: boolean;

  updatedByUser?: {
    firstName: string;
    lastName: string;
  };
  hoverImage?: string | null;
  category?: { category: Category }[];
  canChargeTax: boolean = true;
}

export class NewPackSize {
  name!: string;
  itemCount!: number;
}

export interface ProductCustomer {
  customerId: number;
  customPrice: number | null;
  subsidyAmount: number | null;
  numberOfRequiredDecorations: number;
  product: NewProduct;
  productId?: number;
  id?: number;
  customer?: { name: string };
  productCollection?: {
    id: number;
    collection: { name: string };
    collectionId: string;
    productId: string;
  }[];
  substituteProduct?: NewProduct | null;
  substituteProductId?: number | null;
  substituteRule?: string | null;
  status?: string;
  note?: string;
  approvedByUser?: {
    firstName: string;
    lastName: string;
    email: string;
  };
  approveDate?: string;
}

export interface DecorationCustomer {
  customerId: number;
  customPrice: number | null;
  subsidyAmount: number | null;
  customer?: { name: string };
  id?: number;
}

export interface DecorationProducts {
  productId: number;
  product: NewProduct;
}

export type IHasProduct = {
  product: NewProduct;
};

export interface IMightHaveId<T = number> {
  id?: T;
}

export interface ProductImage {
  name: string;
  url: string;
}

export interface Category extends EnumCreateParams {}

export interface NewProductVariation {
  id?: number;
  guid: string;
  colour: string;
  name: string;
  productCode: string;
  size: string | number;
  displayOrder: null | number;
  imageUrl?: string;
  accessMode: number;
  customers: ProductVariationCustomer[];
  qtyOnHand?: number | null;
  onPurchase?: number | null;
  isObsolete?: boolean;
  purchaseQuantity?: number;
  soldQuantity?: number;
}

export interface ProductVariationCustomer {
  variationId?: number | undefined;
  customerId: number;
  customer?: NewCustomer;
}

export type IProductDraftItem = {
  id: number;
  productId: number | null;
  productJSON: string;
};

export type IProductDrafts = {
  rows: IProductDraftItem[];
  count: number;
};

export type IProductDraftResult = IProductDrafts;

export type IDecorationDraftResult = {
  rows: DecorationDraft[];
  count: number;
};

/**
 * End Code Refactor
 */

export interface IEnum {
  isEdit?: boolean;
  name: string;
  id: string;

  // Used during UI only for ease of display
  children?: any[];
}

export interface Brand extends IEnum {}

export interface Label extends IEnum {}

export interface IValidateProductUriOpts {
  id?: number;
  categories: Category[];
  productName: string;
}

export interface IRequiredField {
  contact: boolean;
  costAccount: boolean;
  employeNumber: boolean;
  jobTittle: boolean;
  businessUnit: boolean;
  startDate: boolean;
  address: boolean;
}

export interface IRequestPrdoductPayload {
  productId: string;
  isUseDecoration: boolean;
  description: string;
}

export interface IBlogCategory {
  id: string;
  name: string;
}

export interface IBlogCreateCategory {
  name: string;
}

export interface INotificationData {
  id: string;
  message: string;
  userId: string;
  externalId?: string;
  isRead: boolean;
  createdAt: string;
  type: string;
}
